import { withVersions } from "v2/hocs/withVersions";
import withPercentageBlock from "../hocs/withPercentageBlock";
import PercentageBlockV1 from "./PercentageBlock/v1";
import PercentageBlockV2 from "./PercentageBlock/v2";
import withXPerformanceBlock from "../hocs/withXPerformanceBlock";
import XPerformanceBlockV1 from "./XPerformanceBlock/v1";
import XPerformanceBlockV2 from "./XPerformanceBlock/v2";
import withPricePerformanceBlock from "../hocs/withPricePerformanceBlock";
import PricePerformanceBlockV1 from "./PricePerformanceBlock/v1";
import PricePerformanceBlockV2 from "./PricePerformanceBlock/v2";

const PercentageBlock = withVersions({
  v1: withPercentageBlock(PercentageBlockV1),
  v2: withPercentageBlock(PercentageBlockV2),
});

const XPerformanceBlock = withVersions({
  v1: withXPerformanceBlock(XPerformanceBlockV1),
  v2: withXPerformanceBlock(XPerformanceBlockV2),
});

const PricePerformanceBlock = withVersions({
  v1: withPricePerformanceBlock(PricePerformanceBlockV1),
  v2: withPricePerformanceBlock(PricePerformanceBlockV2),
});

export { PercentageBlock, XPerformanceBlock, PricePerformanceBlock };
